import React from 'react'

const InvoiceCredited = () => {
  return (
    <div className="row mt-5">
      <div className="col-12 text-center">
        <h1>Fakturan är krediterad!</h1>
      </div>
    </div>
  )
}

export default InvoiceCredited
